export function locatorInit() {

    $(document).ready(() => {
        console.log("locator!");

        (function(d, script) {
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.onload = function() {
                // Script has loaded
                initMap();
            };
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyA9X8bS_JdF__NrMNjI-oPkxLqAlprcd40&libraries=places';
            d.getElementsByTagName('head')[0].appendChild(script);
        }(document));

        $('#locator-getlocation').on('click', function() {
            autoLocate();
        });
    });

    let map = null;
    let originLocation = null;
    let originMarker = null;
    let rankedStores = null;
    let mapCenter = { lat: 43.184748, lng: -84.114975 };

    function autoLocate() {
        navigator.geolocation.getCurrentPosition(async (location) => {
            console.log(location.coords.latitude);
            console.log(location.coords.longitude);
            console.log(location.coords.accuracy);

            originLocation = { "lat": location.coords.latitude, "lng": location.coords.longitude };
            map.setCenter(originLocation);
            map.setZoom(9);

            originMarker = new google.maps.Marker({ map: map });
            originMarker.setPosition(originLocation);
            originMarker.setVisible(true);

            rankedStores = await calculateDistances(map.data, originLocation);
            showStoresList(map.data, rankedStores);
        });
    }

    // https://codelabs.developers.google.com/codelabs/google-maps-simple-store-locator
    function initMap() {
        console.log("init map");
        // Create the map.
        map = new google.maps.Map(document.getElementById('locator-map'), {
            zoom: 7,
            center: mapCenter,
        });

        map.data.loadGeoJson('/stores.json', { idPropertyName: 'storeid' });

        // var storeArr = [{
        //         name: 'Adam\'s Provisioning Center',
        //         location: { lat: 43.181093, lng: -84.128481 },
        //         hours: '8AM to 10PM'
        //     },
        //     {
        //         name: 'Bill\'s Provisioning of Grand Rapids',
        //         location: { lat: 42.963360, lng: -85.668083 },
        //         hours: '9AM to 9PM'
        //     }
        // ];

        // Define the custom marker icons, using the store's "category".
        map.data.setStyle((feature) => {
            return {
                icon: {
                    url: `/imgs/locator/pin_${feature.getProperty('category')}.png`,
                    scaledSize: new google.maps.Size(44, 70),
                },
            };
        });

        // const apiKey = 'AIzaSyBTSrp4BwwC03Ri5FS5MulfKwnozx-mz9s';
        const apiKey = 'AIzaSyA9X8bS_JdF__NrMNjI-oPkxLqAlprcd40';
        const infoWindow = new google.maps.InfoWindow();

        // Show the information for a store when its marker is clicked.
        map.data.addListener('click', (event) => {
            const category = event.feature.getProperty('category');
            const name = event.feature.getProperty('name');
            const description = event.feature.getProperty('description');
            const hours = event.feature.getProperty('hours');
            const phone = event.feature.getProperty('phone');
            const position = event.feature.getGeometry().get();
            const content = `
              <h4>${name}</h4>
              <p>${description}</p>
              <p><b>Open:</b> ${hours}<br/><b>Phone:</b> ${phone}</p>
            `;

            // <p><img src="https://maps.googleapis.com/maps/api/streetview?size=350x120&location=${position.lat()},${position.lng()}&key=${apiKey}"></p>

            infoWindow.setContent(content);
            infoWindow.setPosition(position);
            infoWindow.setOptions({ pixelOffset: new google.maps.Size(0, -30) });
            infoWindow.open(map);
        });

        //**********************//
        //***** SEARCH BAR *****//
        //**********************//

        // Build and add the search bar
        const card = document.createElement('div');
        const titleBar = document.createElement('div');
        const title = document.createElement('div');
        const container = document.createElement('div');
        const input = document.createElement('input');
        const options = {
            // types: ['address'],
            componentRestrictions: { country: 'us' },
        };

        card.setAttribute('id', 'pac-card');
        container.setAttribute('id', 'pac-container');
        input.setAttribute('id', 'pac-input');
        input.setAttribute('type', 'text');
        input.setAttribute('placeholder', 'OR ENTER CITY, ZIP, OR ADDRESS');
        container.appendChild(input);
        card.appendChild(container);
        document.getElementById('locator-search').appendChild(card);

        /* Leaving for posterity */
        /* Part of an attempt to get the "enter" button to work w/ dropdown */
        // enableEnterKey(document.getElementById('pac-input'));
        // enableEnterKey();

        // Make the search bar into a Places Autocomplete search bar and select
        // which detail fields should be returned about the place that
        // the user selects from the suggestions.
        const autocomplete = new google.maps.places.Autocomplete(input, options);

        autocomplete.setFields(['address_components', 'geometry', 'name']);

        // Set the origin point when the user selects an address
        originMarker = new google.maps.Marker({ map: map });
        originMarker.setVisible(false);
        originLocation = map.getCenter();

        /* Leaving for posterity */
        /* Part of an attempt to get the "enter" button to work w/ dropdown */
        // autocomplete.addListener('keypress', async () => {
        //     console.log("** SOMETHING FIRED**");
        //     if (e.key === 'Enter') {
        //         console.log("** ENDTER FIRED**");
        //     }
        // });

        autocomplete.addListener('place_changed', async () => {
            originMarker.setVisible(false);
            originLocation = map.getCenter();
            const place = autocomplete.getPlace();

            if (!place.geometry) {
                // User entered the name of a Place that was not suggested and
                // pressed the Enter key, or the Place Details request failed.
                // window.alert('No address available for input: \'' + place.name + '\'');
                window.alert('Please select an address from the dropdown list.');

                /* Leaving for posterity */
                /* Part of an attempt to get the "enter" button to work w/ dropdown */
                // If the autocomplete is visible, grab the first option
                /*
                if ($('.pac-container:visible').length) {
                    console.log("clicking!");

                    console.log($(".pac-container .pac-item:first .pac-item-query").text());
                    console.log($(".pac-container .pac-item:first span:eq(3)").text());

                    $('#pac-input').trigger({ type: 'keypress', which: 40, keyCode: 40 });

                    if ($(".pac-container .pac-item:first span:eq(3)").text() == "") {
                        let firstValue = $(".pac-container .pac-item:first .pac-item-query").text();
                    } else {
                        let firstValue = $(".pac-container .pac-item:first .pac-item-query").text() + ", " + $(".pac-container .pac-item:first span:eq(3)").text();
                    }
                    console.log(firstValue);
                    event.target.value = firstValue;

                    $('.pac-container .pac-item:first').click();
                } else {
                    window.alert('No address available for input: \'' + place.name + '\'');

                }
                */

                return;
            }

            // Recenter the map to the selected address
            originLocation = place.geometry.location;
            map.setCenter(originLocation);
            map.setZoom(14);

            originMarker.setPosition(originLocation);
            originMarker.setVisible(true);

            // Use the selected address as the origin to calculate distances
            // to each of the store locations
            rankedStores = await calculateDistances(map.data, originLocation);
            showStoresList(map.data, rankedStores);

            return;
        });
    }

    async function calculateDistances(data, origin) {
        const stores = [];
        const destinations = [];

        // Build parallel arrays for the store IDs and destinations
        data.forEach((store) => {
            const storeNum = store.getProperty('storeid');
            const storeLoc = store.getGeometry().get();

            stores.push(storeNum);
            destinations.push(storeLoc);
        });

        // Retrieve the distances of each store from the origin
        // The returned list will be in the same order as the destinations list
        const service = new google.maps.DistanceMatrixService();
        const getDistanceMatrix =
            (service, parameters) => new Promise((resolve, reject) => {
                service.getDistanceMatrix(parameters, (response, status) => {
                    if (status != google.maps.DistanceMatrixStatus.OK) {
                        reject(response);
                    } else {
                        const distances = [];
                        const results = response.rows[0].elements;
                        for (let j = 0; j < results.length; j++) {
                            const element = results[j];
                            const distanceText = element.distance.text;
                            const distanceVal = element.distance.value;
                            const distanceObject = {
                                storeid: stores[j],
                                distanceText: distanceText,
                                distanceVal: distanceVal,
                            };
                            distances.push(distanceObject);
                        }

                        resolve(distances);
                    }
                });
            });

        const distancesList = await getDistanceMatrix(service, {
            origins: [origin],
            destinations: destinations,
            travelMode: 'DRIVING',
            unitSystem: google.maps.UnitSystem.IMPERIAL,
        });

        distancesList.sort((first, second) => {
            return first.distanceVal - second.distanceVal;
        });

        return distancesList;
    }

    function showStoresList(data, stores) {
        // Hide mobile prompt
        // $('#mobile-prompt').css('display', 'none !important');
        $('#mobile-prompt').attr('style', 'display: none !important');

        if (stores.length == 0) {
            console.log('empty stores');
            return;
        }

        let panel = document.getElementById('locator-list');

        // let panel = document.createElement('div');
        // // If the panel already exists, use it. Else, create it and add to the page.
        // if (document.getElementById('panel')) {
        //     panel = document.getElementById('panel');
        //     // If panel is already open, close it
        //     if (panel.classList.contains('open')) {
        //         panel.classList.remove('open');
        //     }
        // } else {
        //     panel.setAttribute('id', 'panel');
        //     const body = document.body;
        //     body.insertBefore(panel, body.childNodes[0]);
        // }


        // Clear the previous details
        while (panel.lastChild) {
            panel.removeChild(panel.lastChild);
        }

        // console.log(stores);

        let markerId = 0;
        stores.forEach((store) => {
            // Add store details with text formatting
            const currentStore = data.getFeatureById(store.storeid);
            console.log(currentStore);

            const wrapper = document.createElement('div');
            wrapper.classList.add('location');
            wrapper.setAttribute('marker-id', markerId);
            wrapper.setAttribute('data-lat', currentStore.getProperty('lat'));
            wrapper.setAttribute('data-lng', currentStore.getProperty('lng'));
            
            const name = document.createElement('h4');
            name.classList.add('place');
            name.textContent = currentStore.getProperty('name');

            const address = document.createElement('p');
            address.classList.add('address');
            address.textContent = currentStore.getProperty('address');

            const distanceText = document.createElement('h5');
            distanceText.classList.add('distance');
            distanceText.textContent = store.distanceText;

            wrapper.appendChild(name);
            wrapper.appendChild(address);
            wrapper.appendChild(distanceText);

            panel.appendChild(wrapper);

            markerId += 1;
        });

        // Open the panel
        panel.classList.add('open');

        enableClickableList(data, stores);

        return;
    }

    function enableClickableList(data, stores) {
        $('div.location').click(function() {
            map.panTo(new google.maps.LatLng(Number($(this).attr('data-lat')), Number($(this).attr('data-lng'))));
        });
    }


    /* Leaving for posterity */
    /* Part of an attempt to get the "enter" button to work w/ dropdown */
    // For "enter -> submit" on Autocomplete
    // https://stackoverflow.com/questions/7865446/google-maps-places-api-v3-autocomplete-select-first-option-on-enter
    // function enableEnterKey(input) {

    // console.log('enableEnterKey');

    // $("#pac-input").keydown(function(e) {
    //     e.preventDefault;
    //     console.log('key pressed');

    //     if (e.which == 13) {
    //         console.log('You pressed enter!');

    //         $('#pac-input').trigger({ type: 'keypress', which: 40, keyCode: 40 });
    //     }
    // });

    /* Store original event listener */
    /*
    const _addEventListener = input.addEventListener

    const addEventListenerWrapper = (type, listener) => {
        console.log('enableEnterKey key trigger');
        if (type === "keydown") {
            // Store existing listener function
            const _listener = listener
            listener = (event) => {
                // Simulate a 'down arrow' keypress if no address has been selected
                const suggestionSelected = document.getElementsByClassName('pac-item-selected').length
                if (event.key === 'Enter' && !suggestionSelected) {
                    const e = JSON.parse(JSON.stringify(event))
                    e.key = 'ArrowDown'
                    e.code = 'ArrowDown'
                    _listener.apply(input, [e])
                }
                _listener.apply(input, [event])
            }
        }
        _addEventListener.apply(input, [type, listener])
    }
    input.addEventListener = addEventListenerWrapper
    */
    // }
}